import { render } from "./hotelCardNew.vue?vue&type=template&id=efb17bc6&scoped=true"
import script from "./hotelCardNew.vue?vue&type=script&lang=js"
export * from "./hotelCardNew.vue?vue&type=script&lang=js"

import "./hotelCardNew.vue?vue&type=style&index=0&id=efb17bc6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efb17bc6"]])

export default __exports__